import { render, staticRenderFns } from "./CurriculumManagement.vue?vue&type=template&id=37a0d596"
import script from "./CurriculumManagement.vue?vue&type=script&lang=js"
export * from "./CurriculumManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports